export const REQUIRED = '*Required';
